/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_Ca_EnInputs */



/**
* | output |
* | --- |
* | "Canadian English" |
*
* @param {Subtitle_Export_Vchip_Type_Ca_EnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_ca_en = /** @type {((inputs?: Subtitle_Export_Vchip_Type_Ca_EnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_Ca_EnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anglais canadien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kanadisches Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese canadese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("канадский английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inglés canadiense")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加拿大英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カナダ英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनाडाई अंग्रेजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês canadense")
	return /** @type {LocalizedString} */ ("Canadian English")
});